import React from "react"
import ExampleItems from "../../ExampleItems.jsx"

export default function ExampleItemsPage() {
  return <ExampleItems />
}

